import { Directive, TemplateRef } from '@angular/core';

/** The business view owns the item's summary, actions and detail content. */
@Directive({ selector: 'ng-template[dataListItem]', standalone: true })
export class DataListItemDirective<T = unknown> {
  constructor(readonly template: TemplateRef<{ $implicit: T }>) {}
}

@Directive({ selector: 'ng-template[dataListDetail]', standalone: true })
export class DataListDetailDirective<T = unknown> {
  constructor(readonly template: TemplateRef<{ $implicit: T }>) {}
}
